module.exports = __webpack_public_path__ + "icons.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/assets/semantic/src/themes/themes/default/assets/fonts/icons.svg
// module id = ../../../../../src/assets/semantic/src/themes/themes/default/assets/fonts/icons.svg
// module chunks = styles